module.exports = __webpack_public_path__ + "img/content.b633ce58.jpg";